import React from 'react';
import CommonInput, { CommonInputProps } from '../InputButton/index';

type TextInputProps = Omit<CommonInputProps, 'type' | 'min'>;

export default function TextInput(props: TextInputProps) {
    return <CommonInput {...props} type="text" />;
}